import { useMutation, useQuery } from "@tanstack/react-query";
import * as bulkApi from "./api";

export function useBulkResources() {
  return useQuery({
    queryKey: ["bulk-import", "resources"],
    queryFn: bulkApi.listBulkResources,
  });
}

export function useImportCsv() {
  return useMutation({
    mutationFn: ({ resource, file }: { resource: string; file: File }) =>
      bulkApi.importCsv(resource, file),
  });
}
